namespace Matrix.Data {
    export class AccountGroupColumns {
        static columnsKey = 'Data.AccountGroup';
    }
}
